<template>
  <div class="globalspin" ref="globalspin">
    <a-spin style="margin-top:350px;" :tip="tip" :spinning="spinning" size="large"></a-spin>
  </div>
</template>

<script>
export default {
  data () {
    return {
      spinning: false,
      tip: ''
    }
  },
  methods: {
    show (tip = '') {
      this.$refs.globalspin.style.display = 'block'
      this.tip = tip
      this.spinning = true
    },
    hide () {
      this.spinning = false
      this.$refs.globalspin.style.display = 'none'
    }
  }
}
</script>

<style lang="less" scoped>
.globalspin {
  display: none;
  text-align: center;
  background: rgba(0,0,0,0.25);
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
}
</style>
